import React from "react";
import ButtonSKA from "../Buttons/ButtonSKA";
import strings from "../../helpers/Localization";
import Inputs from "../Inputs/Inputs";
import IconComponent from "../Icons/IconComponent";
import ButtonSkaRound from "../Buttons/ButtonSkaRound";
import Toggle from "../Inputs/Toggle";

const Modal = ({
    switchButtons,
    expand,
    open,
    hide,
    onClose,
    title,
    icon,
    fields,
    style,
    widthModalPaper,
    heightModalBody,
    textSecondaryButton,
    iconSecondaryButton,
    isSecondaryButtonRed,
    isSecondaryButtonToPrimary,
    isValidationRed,
    isValidationRecording,
    validationTitle,
    validationIcon,
    onValidate,
    disableValidate,
    hideClose,
    noButtonOnRightFooter,
    headerButton,
    headerInfo,
    headerToggle,
    isButtonRoundFooter,
    isButtonGroup,
    textInfoButtonGroup,
    typeFirstButtonGroup,
    onClickFirstButtonGroup,
    iconFirstButtonGroup,
    fillIconFirstButtonGroup,
    reverseIconFirstButtonGroup,
    textFirstButtonGroup,
    typeSecondButtonGroup,
    onClickSecondButtonGroup,
    iconSecondButtonGroup,
    fillIconSecondButtonGroup,
    reverseIconSecondButtonGroup,
    textSecondButtonGroup,
    onClickButtonRoundFooter,
    iconButtonRoundFooter,
    children
}) => {

    let canSave = true;

    // if the object can be named, it must be so.
    if (fields) {
        const name = fields.find(f => f !== null && f !== undefined && f.type === "textfield" && f.title === strings.name);
        if (name !== undefined && (name.value === undefined || name.value === "" || name.value === null)) {
            canSave = false;
        }
    }
    if (disableValidate) {canSave = false;}

    if (!open) {
        return null;
    }

    if (open) {
        return <div className="modal" style={{ visibility: hide ? "hidden" : "visible", width: style && style.width ? style.width : null, height: style && style.height ? style.height : null }}>
            <div className="modal-black-box"/>
            <div className="modal-container">
                <div className="modal-paper" style={{ maxWidth: "calc(100% - 40px)", width: expand ? "calc(100% - 40px)" : widthModalPaper ? widthModalPaper : "600px" }}>
                    <div className="modal-header">
                        {
                            icon ?
                                <IconComponent nameIcon={icon} color="primary-base" />
                                :
                                null
                        }
                        <span>{title ? title : ""}</span>
                        <span style={{ flexGrow: "1" }}/>
                        {
                            headerButton ?
                                headerButton.map((button, index) => {
                                    return (
                                        <ButtonSkaRound
                                            key={index}
                                            type={button.type}
                                            onClick={button.onClick}
                                            nameIcon={button.nameIcon}
                                        />
                                    );
                                })
                                :
                                null
                        }
                        {
                            headerInfo ?
                                <div className="header-info">{headerInfo }</div>
                                :
                                null
                        }
                        {
                            headerToggle ?
                                headerToggle.map((el, index) => {
                                    return (
                                        <Toggle
                                            key={index}
                                            type={el.type}
                                            name={el.name}
                                            checked={el.checked}
                                            onClick={el.onClick}
                                        />
                                    );
                                })
                                :
                                null
                        }
                    </div>
                    <div className="modal-body" style={{
                        width: "auto",
                        maxHeight: heightModalBody ? null : "320px",
                        height: heightModalBody ? heightModalBody : null,
                        overflowY: style && style.overflowY ? style.overflowY : "auto",
                        padding: title === strings.sendContent ? "20px 0" : title.includes(strings.ClientSharescreen) ? "0px" : "20px",
                        boxSizing: style && style.boxSizing ? style.boxSizing : null,
                        border: style && style.border ? style.border : null
                    }}>
                        {fields ? fields.map((item, index) => {
                            if (item) {
                                return <Inputs key={index} field={item}/>;
                            }
                        }) : null}
                        {children}
                    </div>
                    {
                        !hideClose || onValidate ?
                            <div className="modal-footer">
                                {
                                    isButtonRoundFooter ?
                                        <ButtonSkaRound
                                            type="secondary"
                                            onClick={onClickButtonRoundFooter}
                                            nameIcon={iconButtonRoundFooter}
                                        />
                                        :
                                        null
                                }
                                {
                                    isButtonGroup ?
                                        <div className="container-button-group-footer-modal">
                                            <p className="info-button-group-footer-modal">{textInfoButtonGroup}</p>
                                            <ButtonSKA
                                                type={typeFirstButtonGroup}
                                                onClick={onClickFirstButtonGroup}
                                                nameIcon={iconFirstButtonGroup}
                                                fill={fillIconFirstButtonGroup}
                                                specialStroke={onClickSecondButtonGroup ? "primary-icon" : ""}
                                                reverseIcon={reverseIconFirstButtonGroup}
                                                color={fillIconFirstButtonGroup ? "white" : null}
                                                text={textFirstButtonGroup}
                                            />
                                            {
                                                onClickSecondButtonGroup ?
                                                    <ButtonSKA
                                                        type={typeSecondButtonGroup}
                                                        onClick={onClickSecondButtonGroup}
                                                        nameIcon={iconSecondButtonGroup}
                                                        fill={fillIconSecondButtonGroup}
                                                        specialStroke={"primary-icon"}
                                                        reverseIcon={reverseIconSecondButtonGroup}
                                                        color={fillIconSecondButtonGroup ? "white" : null}
                                                        text={textSecondButtonGroup}
                                                    />
                                                    :
                                                    null
                                            }
                                        </div>
                                        :
                                        null
                                }
                                <span style={{ flexGrow: "1", flexShrink: "0" }}/>
                                {
                                    switchButtons && onValidate ?
                                        <ButtonSKA
                                            type={isValidationRed ? "red" : isValidationRecording ? "recording" : "primary-icon"}
                                            isDisabled={!canSave}
                                            onClick={onValidate}
                                            nameIcon={validationIcon ? validationIcon : "check"}
                                            text={validationTitle ? validationTitle : strings.startSearch}
                                        /> : null}
                                {hideClose || noButtonOnRightFooter ? null : <ButtonSKA
                                    type={isSecondaryButtonRed ? "red" : isSecondaryButtonToPrimary ? "primary-icon" : onValidate ? "secondary-icon" : "primary-icon"}
                                    onClick={onClose}
                                    nameIcon={iconSecondaryButton ? iconSecondaryButton : "cancel"}
                                    text={textSecondaryButton ? textSecondaryButton : !onValidate ? strings.Close : strings.cancel}
                                />}
                                {
                                    !switchButtons && onValidate ?
                                        <ButtonSKA
                                            type={isValidationRed ? "red" : isValidationRecording ? "recording" : "primary-icon"}
                                            isDisabled={!canSave}
                                            onClick={onValidate}
                                            nameIcon={validationIcon ? validationIcon : "check"}
                                            text={validationTitle ? validationTitle : strings.startSearch}
                                        /> : null}
                            </div>
                            :
                            null}
                </div>
            </div>
        </div>;
    }
};

export default Modal;
